import type { FunctionComponent } from 'react';

export const HardSkillIcon: FunctionComponent<{
    readonly color?: string;
}> = ({ color = '#6E6E6C' }) => {
    return (
        <svg
            fill="none"
            style={{ minHeight: '12px', minWidth: '12px' }}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_10282_4977)">
                <path
                    d="M31.2637 28.1237C31.5398 28.5931 31.2013 29.1849 30.6567 29.1849H1.63838C1.09378 29.1849 0.75532 28.5931 1.03144 28.1237L15.5406 3.45808C15.8129 2.99524 16.4822 2.99524 16.7545 3.45808L31.2637 28.1237Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_10282_4977">
                    <rect fill="white" height="31.4807" transform="translate(0.405273 0.0613403)" width="31.4807" />
                </clipPath>
            </defs>
        </svg>
    );
};
